import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css, keyframes } from 'styled-components'

// import loadImage from 'blueimp-load-image'
import avatarConfetti from '../../../assets/img/avatar-confetti.png'
import UserIcon from '../../../assets/img/user-icon.png'
// import loadImageLoader from '../../../services/binaries/loadImageLoader'

const Explode = keyframes`
  from {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  to {
    top: -20px;
    left: -40px;
    right: -40px;
    bottom: -20px;
  }
`

const Base = styled.div`
  position: relative;
  display: inline-block;

  ${props =>
    props.hasConfetti &&
    css`
    &::before {
      content: ' ';
      display: block;
      position: absolute;
      top: -20px;
      left: -40px;
      right: -40px;
      bottom: -20px;
      background: url('${avatarConfetti}');
      z-index: 4;
      background-size: 100% 100%;
      animation-name: ${Explode};
      animation-duration: var(--animation-duration);
    }
  `}
`

const SvgPath = styled.path`
  fill: currentColor;
`

const StyledSvg = styled.svg`
  position: absolute;
  bottom: 0;
  left: -1.5%;
  width: 103%;
  height: 103%;
  transition: opacity var(--animation-duration) var(--animation-easing);
  opacity: 0;
`

const UserIconImg = styled.div.attrs(props => ({
  style: {
    backgroundColor: props.color,
    WebkitMaskImage: `url('${props.image}')`,
  },
}))`
  position: absolute;
  bottom: 16%;
  left: 11.62%;

  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;

  height: 75%;
  width: 75%;
`

function Avatar(props) {
  const {
    variant,
    src,
    hasConfetti,
    defaultColor = '#eeeeee',
    ...theProps
  } = props

  const baseRef = React.useRef(null)

  React.useLayoutEffect(() => {
    if (baseRef && baseRef.current.firstChild) {
      baseRef.current.firstChild.remove()
    }

    if (src && baseRef.current) {
      import('../../../services/binaries/loadImage').then(module => {
        module.default(
          src,
          img => {
            const image = img
            if (image && image.style) {
              image.style.cssText = `
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border-radius: 100%;
            `
              if (baseRef.current) {
                baseRef.current.prepend(image)
              }
            }
          },
          {
            meta: true,
            orientation: true,
          },
        )
      })
    }
  }, [src])

  return (
    <Base
      {...theProps}
      variant={variant}
      hasConfetti={hasConfetti}
      ref={baseRef}
    >
      <StyledSvg
        viewBox="0 0 208 211"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        src={src}
      >
        <SvgPath d="M61,98.9628733 L61,88.0371267 C61,86.3603797 59.8815103,85 58.5,85 C57.1197917,85 56,86.3603797 56,88.0371267 L56,98.9628733 C56,100.639621 57.1197917,102 58.5,102 C59.8815103,102 61,100.639621 61,98.9628733 Z" />
        <SvgPath d="M43,115.5 C43,116.880208 44.356705,118 46.028922,118 L57.971078,118 C59.6448728,118 61,116.880208 61,115.5 C61,114.119792 59.6448728,113 57.971078,113 L46.028922,113 C44.356705,113 43,114.11849 43,115.5 Z" />
        <SvgPath d="M148.5,85 C147.119792,85 146,86.3603797 146,88.0371267 L146,98.9628733 C146,100.639621 147.119792,102 148.5,102 C149.88151,102 151,100.639621 151,98.9628733 L151,88.0371267 C151,86.3603797 149.88151,85 148.5,85 Z" />
        <SvgPath d="M146,115.5 C146,116.880208 147.355127,118 149.028922,118 L160.971078,118 C162.643295,118 164,116.880208 164,115.5 C164,114.119792 162.643295,113 160.971078,113 L149.028922,113 C147.355127,113 146,114.11849 146,115.5 Z" />
        <SvgPath d="M79.5028425,151.926741 C86.0998607,157.70655 94.7413886,161 103.499192,161 C113.108068,161 122.515076,157.071943 129.307501,150.226319 C136.201668,143.28469 140,134.048712 140,124.22206 C140,118.648906 135.38128,114 129.854965,114 L77.1450344,114 C71.5508924,114 67,118.585445 67,124.22206 C67,134.73539 71.6251797,145.025793 79.5028425,151.926741 Z M86.2209807,149.300443 C86.2678142,149.263017 86.3114171,149.222337 86.3582506,149.184912 C91.1384643,145.380522 97.5029312,143.89489 103.499192,143.89489 C109.509988,143.89489 115.847001,145.369131 120.641749,149.184912 C120.688582,149.222337 120.732186,149.263017 120.779019,149.300443 C115.73557,152.834718 109.71347,154.751558 103.499192,154.751558 C97.2865294,154.751558 91.2644292,152.834718 86.2209807,149.300443 Z M120.581997,120.248442 L120.581997,122.60788 C120.581997,125.074712 118.590779,127.081048 116.142535,127.081048 L90.8590799,127.081048 C88.4092205,127.081048 86.4180032,125.074712 86.4180032,122.60788 L86.4180032,120.248442 L120.581997,120.248442 Z M73.2013583,124.22206 C73.2013583,122.031852 74.9697141,120.248442 77.1450344,120.248442 L80.2166449,120.248442 L80.2166449,122.60788 C80.2166449,128.519492 84.9903988,133.32949 90.8590799,133.32949 L116.142535,133.32949 C122.009601,133.32949 126.783355,128.519492 126.783355,122.60788 L126.783355,120.248442 L129.85658,120.248442 C132.004447,120.248442 133.798642,122.061141 133.798642,124.22206 C133.798642,132.083056 130.87076,139.488437 125.536623,145.173868 C125.50594,145.146205 125.473641,145.121797 125.442957,145.095762 C119.472535,139.844793 111.299338,137.646448 103.500807,137.646448 C95.7458797,137.646448 87.4951663,139.874082 81.5586573,145.095762 C81.5279738,145.121797 81.495675,145.146205 81.4649911,145.173868 C76.1292391,139.488437 73.2013583,132.084683 73.2013583,124.22206 Z" />
        <SvgPath d="M31.2961393,181.063669 C50.4981832,200.368798 76.0303417,211 103.188732,211 C127.24381,211 150.583603,202.393789 168.911587,186.767823 C170.209044,185.661817 170.369422,183.707765 169.26923,182.405064 C168.169037,181.100751 166.225258,180.939525 164.929404,182.045531 C147.711235,196.725103 125.785975,204.808945 103.188732,204.808945 C77.6758185,204.808945 53.6897028,194.821032 35.6503989,176.686399 C17.6094912,158.550155 7.67408146,134.438897 7.67408146,108.791161 C7.67408146,95.3336777 10.3604111,82.408238 15.6657113,70.2808641 C15.6849567,70.2969864 15.7074094,70.3114966 15.7266551,70.3292315 C19.7778002,73.7181895 26.340463,71.5577692 27.4165987,66.3276174 C28.2553747,62.2566763 31.0523649,59.4303949 35.0906802,58.5742879 C38.5035214,57.8487739 40.7504154,54.7403483 40.7504154,51.3126962 C40.7504154,47.9527594 38.4233327,45.1119678 35.0906802,44.4041882 C34.3625644,44.2510244 33.6408641,44.0220841 32.9608619,43.7173682 C37.0424788,39.2723842 41.5555126,35.2014427 46.4149622,31.5835449 C47.7813817,30.5662129 48.0684582,28.6266713 47.0564737,27.253031 C46.0444896,25.8793906 44.1151436,25.5907971 42.748724,26.6081294 C37.5797448,30.4565792 32.7828424,34.7967673 28.4398094,39.5271201 C27.9779211,38.6581151 27.6315048,37.6972118 27.4165987,36.6508591 C26.7189548,33.2602889 23.5530957,31.0063581 20.1995941,31.0063581 C16.8557154,31.0063581 14.0314606,33.3441262 13.3290057,36.6927779 C12.4773991,40.7540453 9.66597493,43.5674287 5.61482948,44.409025 C2.36236607,45.0861717 0,48.0269229 0,51.4029824 C0,54.7822667 2.24368664,57.8632841 5.62926379,58.5710636 C8.5481408,59.182108 10.8190916,60.8233823 12.1774923,63.2127428 C5.20586619,77.2715972 1.51717454,92.9910729 1.51717454,108.791161 C1.51717454,136.09307 12.0924922,161.75854 31.2961393,181.063669 Z M6.88341861,52.510601 C5.93398156,52.312294 5.89067943,50.6758562 6.86417327,50.472712 C13.3257979,49.1297046 17.9960018,44.4557803 19.3560062,37.969683 C19.5564785,37.0152287 21.177899,36.8894727 21.3863904,37.906805 C22.5715826,43.6625514 26.3597084,47.9979021 31.6938764,49.8632802 C32.3899167,50.1067307 33.097183,50.3098745 33.81728,50.4630387 C34.8436984,50.6806927 34.8565287,52.2961713 33.8188837,52.5154378 C27.3700888,53.8842413 22.722338,58.5791248 21.3863904,65.0732837 C21.2677106,65.6472461 20.7464826,65.7810632 20.2477073,65.7810632 C19.1154396,65.7810632 19.1411001,64.0736862 18.8989294,63.3094781 C17.133169,57.7230179 12.753249,53.7391387 6.88341861,52.510601 Z" />
        <SvgPath d="M201.972468,46.0332817 C197.384081,45.0666311 194.208879,41.8800852 193.258103,37.292949 C192.506893,33.6676053 189.161329,31.3246521 185.55779,31.3246521 C181.998059,31.3246521 178.989972,33.7971397 178.242007,37.338286 C178.156015,37.7447003 178.047309,38.1365416 177.925622,38.5202875 C173.645507,34.070781 168.977619,30.0034014 163.977121,26.3893921 C165.033358,25.2478704 166.448165,24.4512339 168.142039,24.0950144 C171.289659,23.4311509 173.325878,20.6526384 173.325878,17.5114296 C173.325878,14.452799 171.193933,11.8669686 168.143662,11.2241543 C164.948989,10.5505755 162.737542,8.33229901 162.075568,5.13765738 C161.431442,2.02883218 158.588849,0 155.48179,0 C152.415294,0 149.824186,2.12598296 149.181682,5.17004098 C148.508351,8.35820588 146.285547,10.565148 143.082762,11.2273929 C141.661466,11.5204643 140.428377,12.2847172 139.524653,13.3339457 C128.078023,9.08845607 116.048921,6.93332767 103.721282,6.93332767 C86.1724874,6.93332767 68.8394828,11.4314093 53.5946162,19.9401993 C52.0938179,20.7789342 51.5567754,22.6717553 52.3972227,24.1711159 C53.2360472,25.6688572 55.1343541,26.2048058 56.6367752,25.3660704 C70.9535805,17.3754185 87.235215,13.1509781 103.721282,13.1509781 C115.594625,13.1509781 127.172677,15.2737229 138.165011,19.4625411 C138.410006,20.3547093 138.854567,21.1934442 139.448396,21.9010261 C140.363478,22.9923531 141.630638,23.730699 143.00975,24.0707266 C146.141146,24.8446947 148.500239,26.9301983 149.18006,30.1442701 C149.824186,33.1899472 152.433142,35.3159306 155.522353,35.3175496 C157.816546,35.3175496 160.128587,34.1355482 161.309756,32.1455763 C165.998737,35.6235745 170.371333,39.5241785 174.364268,43.7923369 C173.536801,44.4545813 172.605494,44.9937681 171.588196,45.4034205 C170.252891,45.9409882 168.766696,46.0818569 167.491423,46.7651506 C165.471429,47.8467631 164.020928,49.8237815 163.615307,52.1197783 C162.906281,56.1385827 165.437357,60.1784364 169.496814,61.022029 C173.93431,61.9433422 177.296098,65.2529457 178.240384,69.7154052 C178.96888,73.1626388 182.046733,75.7322773 185.611332,75.7322773 C188.452303,75.7322773 191.272181,74.2053906 192.589639,71.6503251 C197.741028,83.6128254 200.348361,96.3395786 200.348361,109.581231 C200.348361,133.809018 191.306253,156.971385 174.886708,174.805031 C173.723386,176.067992 173.806133,178.035295 175.073294,179.196247 C176.301515,180.323196 178.318263,180.268144 179.475095,179.01166 C196.9525,160.028396 206.578703,135.369907 206.578703,109.581231 C206.578703,93.8865211 202.929734,78.2695321 196.027684,64.2765801 C197.541462,62.6590194 199.558211,61.5320703 201.970846,61.023648 C205.652264,60.2480608 207.999999,57.0016054 207.999999,53.3341633 C208.001622,49.7833017 205.522465,46.7797235 201.972468,46.0332817 Z M155.523975,29.0918034 C155.405534,29.0756114 155.31143,29.0237977 155.277357,28.8618797 C155.132956,28.1769665 154.936635,27.4855771 154.698131,26.8281899 C153.46342,23.4230547 151.06052,20.7643617 147.870715,19.2050914 C146.786895,18.6756199 145.615461,18.2659671 144.362903,18.0052793 C144.250951,17.9826106 144.16496,17.8806026 144.16496,17.7656407 L144.168204,17.56972 C144.173072,17.4385662 144.242839,17.3365581 144.345055,17.3155089 C150.001037,16.14808 154.088076,12.0871771 155.277357,6.45243137 C155.303317,6.33585043 155.381196,6.2176504 155.48179,6.2176504 L155.695959,6.2176504 C155.84036,6.2176504 155.950689,6.29051339 155.973403,6.39737947 C157.143215,12.0402209 161.210784,16.1189349 166.855409,17.3074127 C166.97385,17.3333196 167.093914,17.4110402 167.093914,17.5114296 L167.093914,17.8061201 C167.093914,17.9081285 166.97385,17.9858491 166.855409,18.011756 C162.054476,19.0221242 158.402263,22.1293303 156.695409,26.5043539 C156.388759,27.2912755 156.143764,28.0960078 155.973403,28.9217897 C155.952311,29.0237977 155.850094,29.0998992 155.736521,29.0998992 C155.661886,29.0998992 155.588875,29.1015183 155.523975,29.0918034 Z M201.748566,53.7195279 C201.672309,54.3170051 201.386751,54.7914251 200.685838,54.9403897 C193.877892,56.3749827 188.562632,61.7101803 187.155938,68.5058778 C186.860646,69.9339945 184.623239,69.7785533 184.337682,68.4297766 C182.90016,61.6227444 177.644932,56.3620293 170.767219,54.9339129 C170.022499,54.7784717 169.733696,54.1210845 169.733696,53.4329332 C169.733696,52.837075 170.131205,52.2525512 170.74775,52.126255 C177.586522,50.711092 182.890425,45.4762839 184.339304,38.6190573 C184.623239,37.2702803 186.862268,37.1342696 187.155938,38.5510516 C188.611306,45.5669579 193.668591,50.6366096 200.685838,52.1149206 C201.475988,52.2833153 201.845914,52.9585136 201.748566,53.7195279 Z" />
      </StyledSvg>
      {/* {src && <StyledImage image={src} variant={variant} />} */}
      {!src && <UserIconImg image={UserIcon} color={defaultColor} />}
    </Base>
  )
}

Avatar.defaultProps = {
  variant: 'circle',
  src: null,
}

Avatar.propTypes = {
  variant: PropTypes.oneOf(['circle', 'square']),
  src: PropTypes.string,
}

export default Avatar
